// extracted by mini-css-extract-plugin
export default {"languageSwitch":"styles_languageSwitch__+4EVM"};